import { render } from 'preact';
import App from './App';
import './normalize.css';
import './index.css';

const rootElement = document.getElementById('root');
if (rootElement) {
  rootElement.classList.add('auth-front-root');
  render(<App />, rootElement);
} else {
  console.error('Root element not found');
}
